<div *ngIf="column.type === 'text'" class="site-column">
    <customer-site-column-image *ngIf="column.image" class="column-image--with-text" [column]="column"></customer-site-column-image>
    <customer-site-column-text *ngIf="column.html">

        <div class="customer-site-column-text-content" [innerHTML]="column.html | safe: 'html'"></div>

    </customer-site-column-text>

</div>


<div *ngIf="column.type === 'image'" class="site-column">

    <customer-site-column-image [column]="column"></customer-site-column-image>

</div>


<div *ngIf="column.type === 'video'" class="site-column">

    <customer-site-column-video [column]="column"></customer-site-column-video>

</div>
<div *ngIf="column.type === 'cta'">
  <customer-site-column-cta 
    [ngStyle]="getColumnBackgroundStyle(column)">

        <!--Use the text editor if we are in edit mode-->
        <div class="customer-site-column-text-content" [innerHTML]="column.html | safe: 'html'"></div>

        <!-- put button code here -->
        <a *ngIf="column.buttonLink" class="customer-site-column-button cta-button" [style.backgroundColor]="theme.buttonColor" [href]="column.buttonLink.url"  target="_blank" >{{column.buttonLink.text}}</a>
    
  </customer-site-column-cta>
</div>



<div *ngIf="column.type === 'testimonial'" class="site-column">

    <customer-site-column-testimonial>

        <customer-site-column-text class="customer-site-column-testimonial-content" *ngIf="column.html">

            <div class="customer-site-column-text-content" [innerHTML]="column.html | safe: 'html'"></div>

        </customer-site-column-text>

    </customer-site-column-testimonial>

</div>

<!-- HTML column -->
<div *ngIf="column.type === 'html'" class="site-column" [innerHtml]="column.html | safe: 'html'" class="column-html"></div>

